export const getRowErrorMessages = (tableIndex, inputData, tables, errors) => {
    const rowErrorMessages = [];
  
    // Loop through each row in the table
    tables[tableIndex]?.rows?.forEach((row, rowIndex) => {
      const rowErrors = errors?.[tableIndex]?.[rowIndex];
  
      if (rowErrors) {
        // Collect missing field names and their associated error messages
        const missingFields = Object.keys(rowErrors)
          .map((fieldName) => {
            const fieldTitle =
              inputData[tableIndex]?.fields?.find(
                (field) => field.fieldName === fieldName
              )?.title || fieldName; // Fallback to the fieldName if title is missing
  
            const errorMessage =
              rowErrors[fieldName] !== "Required"
                ? ` - ${rowErrors[fieldName]}`
                : "";
  
            return `${fieldTitle}${errorMessage}`;
          })
          .filter(Boolean); // Remove undefined or empty strings
  
        if (missingFields.length) {
          rowErrorMessages.push(
            `Row ${rowIndex + 1}: Missing fields - ${missingFields.join(", ")}`
          );
        }
      }
    });
  
    return rowErrorMessages;
  };
  